import { capitalize } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader } from "../../Common/Loader";
import { ErrorModel } from "../../Model/ErrorModel";
import { SuccessModel } from "../../Model/SuccessModel";
import { addIntegration } from "../../Redux/Slice/Integration/AddIntegrationSlice";

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const splittedPath = location.pathname.split("/");
  const provider = splittedPath[splittedPath.length - 1];
  const [loading, setLoading] = useState(true);
  const [successModal, setSuccessModal] = useState({
    visible: false,
    message: "",
  });
  const [errorModal, setErrorModal] = useState({ visible: false, message: "" });

  const showSuccessMessage = (message, callback) => {
    setSuccessModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setSuccessModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 3000);
  };

  const showErrorMessage = (message, callback) => {
    setErrorModal({
      visible: true,
      message: message ?? "Something went wrong, please try again later!",
    });

    setTimeout(() => {
      setErrorModal({ visible: false, message: "" });
      if (typeof callback === "function") {
        callback();
      }
    }, 2000);
  };

  const addIntegrationProviderByCode = async (code) => {
    const payload = {
      code: code,
      provider: provider,
    };
    setLoading(true);
    const result = await dispatch(addIntegration(payload));
    if (
      addIntegration.fulfilled.match(result) &&
      result?.payload?.data?.success === true
    ) {
      setLoading(false);
      showSuccessMessage(
        `${capitalize(provider)} integration enabled successfully!`,
        () => navigate("/integration", { replace: true })
      );
    } else {
      setLoading(false);
      showErrorMessage(
        result?.payload?.error?.message ?? result?.payload?.data?.message,
        () => navigate("/integration", { replace: true })
      );
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get("code");

    if (!authCode) {
      setLoading(false);
      showErrorMessage("No authorization code found", () =>
        navigate("/integration", { replace: true })
      );
      return;
    }

    addIntegrationProviderByCode(authCode);
  }, [navigate]);

  return (
    <div className="auth-callback">
      {loading && <Loader />}
      {errorModal.visible && <ErrorModel message={errorModal.message} />}
      {successModal.visible && <SuccessModel message={successModal.message} />}
    </div>
  );
};

export default AuthCallback;
